window.FitnessMarkDashboard = new (function () {
  const { COLORS } = CONSTANTS;
  const { chartCustomLabels, callApi } = Shared;

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 20,
        right: 35,
        bottom: 40,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(0,0,0,0)",
        },
        ticks: {
          display: false,
        },
      },
      y: {
        ticks: {},
      },
    },
    interaction: {
      mode: "index",
    },
    animations: {
      tension: {
        duration: 1000,
        easing: "linear",
        from: 1,
        to: 0,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxHeight: 2,
          boxWidth: 14,
          padding: 40,
        },
      },
      tooltip: {
        usePointStyle: true,
      },
    },
  };

  const drawResultsChart = (wrapper) => {
    const chartContainer = wrapper.querySelector(".results-chart canvas");
    const current_year = document.querySelector(".current-year-group").innerHTML;
    const student_id = document.querySelector(".student-id").innerHTML;
    const physical_exercise_id = $(wrapper).data("exercise-id");

    const isTeacher = !!wrapper.querySelector(".class-median-percentile");

    if (!student_id || !physical_exercise_id || !chartContainer) return;

    let params = new URLSearchParams({
      student_id,
      physical_exercise_id,
      current_year,
      include: "student_year",
      sort: "examined_at",
      direction: "asc",
    });

    const parsedYear = parseInt(current_year, 10);
    if (!isNaN(parsedYear)) {
      for (let i = 1; i <= parsedYear; i++) params.append("year_group[]", i);
    }

    params.append("cohort[]", 1);
    params.append("cohort[]", 2);
    if (isTeacher) params.append("cohort[]", 3);

    return callApi({ url: `/api/fitness_marks?${params}` }).then((json) => {
      const dataFormatter = new Jsona();
      const data = dataFormatter.deserialize(json);

      const labels = data.map((d) => ordinal(d["student-year"]["academical-year"]) + " year -" + d["examined-at"]);
      const scoreDataset = data.map((d) => +d.value);
      const schoolDataset = data.map((d) => +d["school-stats"].q2);
      const databaseDataset = data.map((d) => +d["database-stats"].q2);
      const measureInterval = $(wrapper).data("measure-interval");

      const decoratedValues = data.map((d) => d["decorated-value"]);
      const decoratedSchoolQ2 = data.map((d) => d["school-stats"]["decorated-q2"]);
      const decoratedDatabaseQ2 = data.map((d) => d["database-stats"]["decorated-q2"]);
      const decoratedClassQ2 = data.map((d) => d["class-stats"]["decorated-q2"]);

      const shouldHideYAxis = decoratedValues.some((decorated, index) => +decorated !== scoreDataset[index]);

      if (measureInterval) {
        chartOptions.scales.y.ticks.stepSize = +measureInterval;
      }

      const datasets = [
        {
          data: scoreDataset,
          label: "Your Result",
          borderColor: COLORS.fitness.score,
          fill: false,
          backgroundColor: COLORS.fitness.score,
          borderWidth: 3,
          pointBorderColor: COLORS.fitness.score,
          pointRadius: 3,
          pointStyle: "rect",
        },
        {
          data: schoolDataset,
          label: "School Year Group Median",
          borderColor: COLORS.fitness.year,
          fill: false,
          borderDash: [2, 2],
          backgroundColor: COLORS.fitness.year,
          pointBorderColor: COLORS.fitness.year,
          pointRadius: 6,
          pointStyle: "circle",
        },
        {
          data: databaseDataset,
          label: "Athena FitnessMark Database Median",
          borderColor: COLORS.fitness.database,
          fill: false,
          borderDash: [2, 2],
          backgroundColor: COLORS.fitness.database,
          pointBorderColor: COLORS.fitness.database,
          pointRadius: 6,
          pointStyle: "rect",
        },
      ];

      if (isTeacher) {
        const classDataset = data.map((d) => +d["class-stats"].q2);

        datasets.push({
          data: classDataset,
          label: "Class median",
          borderColor: COLORS.fitness.class,
          fill: false,
          borderDash: [2, 2],
          backgroundColor: COLORS.fitness.class,
          pointBorderColor: COLORS.fitness.class,
          pointRadius: 6,
          pointStyle: "triangle",
        });
      }

      new Chart(chartContainer, {
        type: "line",
        data: {
          labels,
          datasets,
        },
        options: {
          ...chartOptions,
          scales: {
            ...chartOptions.scales,
            y: shouldHideYAxis ? { ticks: { display: false } } : chartOptions.scales.y,
          },
          plugins: {
            ...chartOptions.plugins,
            tooltip: {
              ...chartOptions.plugins.tooltip,
              callbacks: {
                label: function (context) {
                  const index = context.dataIndex;

                  if (context.dataset.label === "Your Result" && decoratedValues[index]) {
                    return `Your result: ${decoratedValues[index]}`;
                  }

                  if (context.dataset.label === "School Year Group Median" && decoratedSchoolQ2[index]) {
                    return `Year group median: ${decoratedSchoolQ2[index]}`;
                  }

                  if (context.dataset.label === "Athena FitnessMark Database Median" && decoratedDatabaseQ2[index]) {
                    return `Database median: ${decoratedDatabaseQ2[index]}`;
                  }

                  if (context.dataset.label === "Class median" && decoratedClassQ2[index]) {
                    return `Class median: ${decoratedClassQ2[index]}`;
                  }

                  return context.raw;
                },
              },
            },
          },
        },
        plugins: [chartCustomLabels],
      });
    });
  };

  this.createCharts = (isPdf) => {
    let wrapper = isPdf ? ".fitness-marks-full-student-download" : ".fitness-mark-students";

    if (!$(wrapper) || !$(wrapper).length) return;

    $(".containers", wrapper).each(function () {
      drawResultsChart(this);
    });
  };

  this.setSelects = () => {
    let wrapper = ".fitness-mark-students";

    if (!$(wrapper) || !$(wrapper).length) return;

    $("#current_year_fitness_marks_download_pdf", wrapper).select2({
      placeholder: "Please select",
      minimumResultsForSearch: Infinity,
    });

    $("#teacher_id_fitness_marks_download_pdf", wrapper).select2({
      placeholder: "Please select",
      ajax: {
        dataType: "json",
        url: "/teacher_entities/autocomplete",
        delay: 250,
        data: (params) => ({
          ...params,
          subject: $("#subject_fitness_marks_download_pdf", wrapper).text(),
          current_year: $("#current_year_fitness_marks_download_pdf", wrapper).val(),
        }),
      },
    });
  };

  this.bindEvents = () => {
    let wrapper = ".fitness-mark-students";
    if (!$(wrapper) || !$(wrapper).length) return;

    let download_button = ".fitness-marks-single-download-button";

    $(download_button, wrapper).on("click", function () {
      setTimeout(() => {
        $(download_button, wrapper).prop("disabled", false);
        $(download_button, wrapper).prop("value", "Download");
      }, 5000);
    });
  };
})();
